import { legacy_createStore as createStore } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/es/storage";
import rootReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["queue.queue"],
};

const configureStore = () => {
  const enhancers = composeWithDevTools();
  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = createStore(persistedReducer, enhancers);
  const persistor = persistStore(store);

  if (import.meta.env.DEV && import.meta.hot) {
    import.meta.hot.accept("./reducers", () => store.replaceReducer(persistedReducer));
  }

  return { store, persistor };
};

export { configureStore };
